var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tooltip',{attrs:{"content":_vm.text,"disabled":!_vm.isOverflowing,"placement":"top","effect":"dark","popper-class":"disease-table-tooltip"}},[_c('span',{ref:"text",staticClass:"overflow-text",on:{"mouseenter":_vm.measureOverflow}},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }